<!-- can be used as normal dropdown -->
<div class="dropdown dropdown-brand" [ngClass]="{ 'border-danger': showError }" *ngIf="!isPopover">
    <button class="dropdown-toggle"  type="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-bs-display="static" [title]="selected" [ngClass]="{ 'text-transparent': !selected && !placeholder }">
        {{selected ? selected : (placeholder ? placeholder : '')}}
    </button>
    <ng-template [ngTemplateOutlet]="menuContent"></ng-template>
</div>

<!-- can be used as popover dropdown when dropdown appears in a table or a container -->
<div class="dropdown dropdown-brand popover-brand w-100" [ngClass]="{ 'border-danger': showError }" *ngIf="isPopover">
    <button type="button" (click)="dropdownVisible=true" class="dropdown-toggle" placement="bottom-left" [ngbPopover]="popoverMenu" [title]="selected" [autoClose]="'outside'"  [ngClass]="{ 'text-transparent': !selected && !placeholder }">
        <span>{{selected ? selected : (placeholder ? placeholder : '')}}</span>
    </button>
    <ng-template #popoverMenu>
        <ng-template [ngTemplateOutlet]="dropdownVisible?menuContent:''"></ng-template>
    </ng-template>
</div>

<ng-template #menuContent>
    <div class="dropdown-menu">

        <!-- search -->
        <div *ngIf="showSearch" class="dropdown-item dropdown-item-search" onclick="event.stopPropagation();">
            <div class="input-group">
                <input type="text" class="form-control" [ngClass]="isSingleSelect ? 'w-75':''" placeholder="Search" [(ngModel)]="search">
                <div class="input-group-append">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                </div>
            </div>
        </div>

        <!-- checkboxes -->
        <ng-container>
        <div class="dropdown-item-checkboxes" [ngClass]="{'hide-overflow':filterList.length < 10,'auto-overflow':filterList.length >= 10}" *ngIf="!isSingleSelect">
            <ng-container *ngFor="let item of filterList; let i = index;">
                <div class="dropdown-item" onclick="event.stopPropagation();" *ngIf="item.visible" [ngClass]="{ 'checked': item.checked }">
                    <!-- checkbox -->
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" [id]="'chkItem' + item.uuid" (change)='onChange($event, item)' [checked]="item.checked">
                        <label class="form-check-label" [for]="'chkItem' + item.uuid">
                            <span [title]="item.name">{{item.name}}</span>
                        </label>
                    </div>
                </div>
            </ng-container>
        </div>
        </ng-container>

        <!-- Radio Buttons-->
        <div class="dropdown-item-checkboxes" [ngClass]="{'hide-overflow':filterList.length < 10,'auto-overflow':filterList.length >= 10}" *ngIf="isSingleSelect">
            <ng-container *ngFor="let item of filterList;">
                <div class="dropdown-item p-0" onclick="event.stopPropagation(); " *ngIf="item.visible ">
                    <!-- Radio -->
                    <div (click)="onChange($event, item)" class="form-check ">
                        <label  class="form-check-label">
                        <span [title]="item.project ">{{item.name}}</span>
                    </label>
                    </div>
                </div>
            </ng-container>
        </div>


        <!-- not found -->
        <div class="dropdown-item dropdown-item-empty " *ngIf="isEmpty ">
            Not found
        </div>
    </div>
</ng-template>  